/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
* */

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {AccordianItem} from "./components";

const propTypes = {
  accordianList: PropTypes.array
};

const defaultProps = {
  accordianList: []
};

const AccordianFaq = ({
  accordianList
}) => (
  <AccordianWrapper>
    {
      accordianList.map((item, index) => (
        <AccordianItem
          content={item.content}
          key={index}
          title={item.title}
        />
      ))
    }
  </AccordianWrapper>
);

const AccordianWrapper = styled.div``;

AccordianFaq.propTypes = propTypes;
AccordianFaq.defaultProps = defaultProps;

export default AccordianFaq;
